export default __webpack_public_path__ + "static/Futura-BoldCondensed-4e1140466cdbec47d5e25d11c7a6b060.woff2";